import { render, staticRenderFns } from "./PreLancamento.vue?vue&type=template&id=2d5e218b&"
import script from "./PreLancamento.vue?vue&type=script&lang=js&"
export * from "./PreLancamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports